// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import { translateFunc, translations } from '../../../shared/localize'
import { linkColor } from '../../controls/colors'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  white-space: nowrap;
`
const Tip: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  font-size: 12px;
`
const Link: StyledComponent<Object, any, any> = styled.a`
  display: inline-block;
  font-size: 12px;
  padding-left: 5px;
  text-decoration: underline;
  color: ${linkColor};
`

const t = translateFunc(translations.ad_edit)

type Props = {|
  url: string
|}

export default class AutoUtmTip extends Component<Props> {
  render() {
    return (
      <Wrapper>
        <Tip>{this.isAutoUtms() ? t('auto_utms') : t('our_utms')}</Tip>
        <Link href="/ru/blog/utm-in-oneretarget/" target="_blank">
          {t('more_info')}
        </Link>
      </Wrapper>
    )
  }

  isAutoUtms() {
    let { url } = this.props

    if (!url) return true

    let matches = url.match(/.[^?]+\?(.+)/)
    let search = matches && matches[1]
    let utmParams = _.map(['source', 'medium', 'campaign', 'content'], (type) => 'utm_' + type)
    let params = new window.URLSearchParams(search)

    return _.every(utmParams, (utmParam) => !params.has(utmParam))
  }
}
